import React from 'react'

import { Grid } from '@material-ui/core'

import SideTabs from './Tabs'
import VerticalTabs from './VerticalTabs'

const ContentAppBarTabs = (vehiculoTipo) => {
  const [value, setValue] = React.useState(0)

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }
  return (
    <div>
      <Grid container>
        <Grid item sm={3} container justify="center" alignItems="center">
          <VerticalTabs value={value} onChange={handleChange} />
        </Grid>
        <Grid item sm={9} xs={12}>
          <SideTabs value={value} vehiculoTipo={vehiculoTipo} />
        </Grid>
      </Grid>
    </div>
  )
}

export default ContentAppBarTabs
